import React from 'react';
import PropTypes from 'prop-types';

import Action from '../Action';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: PropTypes.node,
};

const SecondaryAction = ({
  children,
  ...rest
}) => (
  <Action
    className="bg-gray-200 text-gray-900 hover:bg-gray-900 hover:text-gray-100"
    {...rest}
  >
    {children}
  </Action>
);

SecondaryAction.defaultProps = defaultProps;
SecondaryAction.propTypes = propTypes;

export default SecondaryAction;
